






















































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storePpiIdo } from "@/store/modules/PpiIdoStore";
import { appModule } from "@/store/modules/app";
import PpiIdoSvc from "@/services/PpiIdoService";
import BundleItemTriState from "@/components/pemeriksaan/bundle-ppi/BundleItemTriState.vue";
import BundleObservasiList from "@/components/pemeriksaan/bundle-ppi/BundleObservasiList.vue";
import {
  labelObservasi,
  nowHm,
  todayIso,
  trimJam,
  trimTanggal
} from "@/utils/bundlePpiObservasi";

@Component({
  components: { BundleItemTriState, BundleObservasiList }
})
export default class PpiIdoPage extends Vue {
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  @Prop({ default: false }) isActive!: boolean;

  get readOnly(): boolean {
    return false;
  }

  form: any = this.defaultForm();
  saving = false;
  prefilling = false;
  deleteDialog = false;
  deleting = false;
  loaded = false;
  rowToDelete: any = null;
  showForm = false;

  /** null = item belum/tidak dinilai (tidak masuk denominator kepatuhan). */
  defaultForm() {
    return {
      tanggal_observasi: todayIso(),
      jam_observasi: nowHm(),
      pre_mandi: null,
      pre_hand_hygiene: null,
      pre_tidak_cukur: null,
      pre_clipper: null,
      pre_antibiotik_1jam: null,
      pre_glukosa_normal: null,
      pre_normotermia: null,
      peri_suhu_ok_22_27: null,
      peri_kelembapan_40_60: null,
      peri_hand_hygiene_tim: null,
      peri_desinfeksi_kulit: null,
      peri_batasi_petugas: null,
      peri_pintu_tertutup: null,
      peri_normotermia: null,
      peri_glukosa_kontrol: null,
      peri_oksigen_tambahan: null,
      post_hand_hygiene_luka: null,
      post_perawatan_aseptik: null,
      post_buka_balutan_24_48: null,
    };
  }

  get ppiIdo() { return storePpiIdo.currentItem; }
  get list() { return storePpiIdo.list; }
  get loading() { return storePpiIdo.loading; }

  get judulForm(): string {
    return this.ppiIdo && this.ppiIdo.id
      ? "Ubah Observasi — " + labelObservasi(this.ppiIdo)
      : "Observasi Baru";
  }

  /** Persen dihitung atas item yang DINILAI saja (kepatuhan_total dari server). */
  get kepatuhanPersen() {
    if (!this.ppiIdo) return 0;
    const total = this.ppiIdo.kepatuhan_total || 0;
    if (!total) return 0;
    const count = this.ppiIdo.kepatuhan_count || 0;
    return Math.round((count / total) * 1000) / 10;
  }

  get kepatuhanColor() {
    const persen = this.kepatuhanPersen;
    if (persen >= 80) return "success";
    if (persen >= 50) return "warning";
    return "error";
  }

  @Watch("isActive", { immediate: true })
  onActiveChange(val: boolean) {
    if (val && !this.loaded) {
      this.fetchData();
      this.loaded = true;
    }
  }

  @Watch("ppiIdo", { immediate: true })
  onDataChange() {
    if (this.ppiIdo) this.populateForm();
    else this.form = this.defaultForm();
  }

  async fetchData() {
    await storePpiIdo.getByRegister(this.register);
  }

  /** null dari server = "tidak dinilai" — harus ikut tersalin, jangan di-skip. */
  populateForm() {
    const d = this.ppiIdo;
    Object.keys(this.form).forEach(key => {
      if (d[key] !== undefined) this.form[key] = d[key];
    });
    this.form.tanggal_observasi = trimTanggal(d.tanggal_observasi) || todayIso();
    this.form.jam_observasi = trimJam(d.jam_observasi);
  }

  labelObservasi(row: any): string { return labelObservasi(row); }

  async tambahObservasi() {
    const kosong = !this.list.length;
    storePpiIdo.select(null);
    this.showForm = true;
    if (kosong && !this.readOnly) await this.pullPrefill(true);
  }

  pilihObservasi(row: any) {
    storePpiIdo.select(row);
    this.showForm = true;
  }

  tutupForm() {
    storePpiIdo.select(null);
    this.showForm = false;
  }

  cetakObservasi(row: any) { PpiIdoSvc.printPdf(row.id); }

  async pullPrefill(auto = false) {
    this.prefilling = true;
    try {
      const resp = await PpiIdoSvc.prefill(this.register);
      const payload = resp?.data?.data;
      if (!payload?.has_source) {
        // Saat auto-tarik, jangan ganggu user bila memang belum ada sumber.
        if (!auto) appModule.NoticeDelay("Belum ada data Checklist OK / Askep Perioperatif untuk ditarik.");
        return;
      }
      const values = payload.values || {};
      Object.keys(values).forEach(key => {
        if (!(key in this.form)) return;
        const v = values[key];
        // Sumber tanpa nilai tetap "tidak dinilai" (null), bukan otomatis "Tidak".
        this.form[key] = v === null || v === undefined ? null : !!v;
      });
      if (payload.filled_count > 0 || !auto) {
        appModule.NoticeDelay(
          `${payload.filled_count} item terisi otomatis dari Checklist OK & Askep Perioperatif. Periksa & simpan.`
        );
      }
    } catch (e) {
      /* handled by service */
    } finally {
      this.prefilling = false;
    }
  }

  async save() {
    if (!this.form.tanggal_observasi) {
      appModule.NoticeDelay("Tanggal Observasi harus diisi");
      return;
    }
    this.saving = true;
    try {
      let resp;
      if (this.ppiIdo?.id) {
        resp = await PpiIdoSvc.update(this.ppiIdo.id, { ...this.form, register_id: this.register, pasien_rm: this.rm });
      } else {
        resp = await PpiIdoSvc.create({ ...this.form, register_id: this.register, pasien_rm: this.rm });
      }
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menyimpan Bundle IDO");
        await storePpiIdo.getByRegister(this.register);
        if (resp.data.data?.id) await storePpiIdo.refresh(resp.data.data.id);
      }
    } catch (e) { /* handled by service */ }
    this.saving = false;
  }

  confirmDelete(row: any) {
    this.rowToDelete = row || this.ppiIdo;
    this.deleteDialog = true;
  }

  async doDelete() {
    if (!this.rowToDelete?.id) {
      this.deleteDialog = false;
      return;
    }
    const terpilih = this.ppiIdo && this.ppiIdo.id === this.rowToDelete.id;
    this.deleting = true;
    try {
      const resp = await PpiIdoSvc.destroy(this.rowToDelete.id);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menghapus observasi Bundle IDO");
        if (terpilih) this.tutupForm();
        await storePpiIdo.getByRegister(this.register);
        this.deleteDialog = false;
        this.rowToDelete = null;
      }
    } catch (e) { /* handled by service */ }
    this.deleting = false;
  }

  beforeDestroy() { storePpiIdo.reset(); }
}
